/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Offline_Processing_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo is writing your report…" |
*
* @param {Meeting_Offline_Processing_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_processing_body = /** @type {((inputs?: Meeting_Offline_Processing_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Processing_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo is je verslag aan het schrijven…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo est en train de rédiger votre compte rendu…")
	return /** @type {LocalizedString} */ ("Wundo is writing your report…")
});